/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps } from '@mui/material';

export const headerMobileDrawerSX: SxProps = {
	width: 250,
	p: 2,
};

export const headerMobileDrawerBoxSX: SxProps = {
	minWidth:30,
	display:headerBreak({mobile:'block', desktop:'none'})
};